import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const retailerCollectionsFlyersAccessControl: DomainAccessControlConfig = {
  permissions: [
    Permission.Flyers,
    Permission.CatalogProductsView,
    Permission.StoreConfigsView,
    Permission.RetailerCollectionsView,
  ],
}

export const flyerPageBuilderAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.Flyers,
      Permission.CatalogProductsView,
      Permission.StoreConfigsView,
      Permission.RetailerCollectionsView,
    ],
    warehouseFeatureToggles: [FeatureToggle.retailerCreateDigitalFlyerEnabled],
  },
  {
    permissions: [
      Permission.Flyers,
      Permission.CatalogProductsView,
      Permission.StoreConfigsView,
      Permission.RetailerCollectionsView,
    ],
    featureToggles: [FeatureToggle.retailerCreateDigitalFlyerEnabled],
    restrictedBannersAllowed: true,
  },
]

export const retailerCollectionsDigitalFlyersAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.Flyers,
      Permission.CatalogProductsView,
      Permission.StoreConfigsView,
      Permission.RetailerCollectionsView,
    ],
    warehouseFeatureToggles: [FeatureToggle.retailerCreateDigitalFlyerEnabled],
  },
  {
    permissions: [
      Permission.Flyers,
      Permission.CatalogProductsView,
      Permission.StoreConfigsView,
      Permission.RetailerCollectionsView,
    ],
    featureToggles: [FeatureToggle.retailerCreateDigitalFlyerEnabled],
    restrictedBannersAllowed: true,
  },
]
